import { fetchAffiliateAdverts, setAffiliateAdverts, updateAffiliateAdvertsInDom } from "@modules/azm/affiliates"
import { filterConfig } from "@modules/global/filter-config.ts"

let categories: string[] = []

export function setCategories(newCategories: string[]) {
    categories = newCategories
}

export async function addCategory(category: string) {
    if (!categories.includes(category)) {
        categories.push(category)
        setAffiliateAdverts(await fetchAffiliateAdverts())
        updateAffiliateAdvertsInDom()
    }
}

export function getCategories() {
    return categories
}

export function getCategoriesAsString() {
    return categories.join(filterConfig.delimiterValues)
}

export async function removeCategory(removeCategory: string) {
    categories = categories.filter((category) => category !== removeCategory)
    setAffiliateAdverts(await fetchAffiliateAdverts())
    updateAffiliateAdvertsInDom()
}

export function parseCategoriesFromLocation() {
    const pathSplit = location.pathname.split("/")
    const sexAnzeigenKeyIndex = pathSplit.findIndex((path) => path.includes("sex-anzeigen"))
    const maybeCategoryString = pathSplit[sexAnzeigenKeyIndex + 1]
    if (maybeCategoryString && !maybeCategoryString.includes(filterConfig.delimiterGroupValue)) {
        categories = maybeCategoryString.split(filterConfig.delimiterValues)
    } else {
        categories = []
    }
}

parseCategoriesFromLocation()
